const CHANGE_SETTLT_ACCOUNT_CONDITIN = 'CHANGE_SETTLT_ACCOUNT_CONDITIN';

const SettleAccountModel = function (){
    const name = 'settlt_account';
    return {
        name,
        state:{
            condition:{
                mchNo:'',
                userId:'',
                remark:'',
                mobile:'',
            }
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:CHANGE_SETTLT_ACCOUNT_CONDITIN,
                    key,
                    value
                })
            }
        },
        reducers:{
            condition:(state = SettleAccountModel.state.condition, action) => {
                if(action.type === CHANGE_SETTLT_ACCOUNT_CONDITIN){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            }
        }
    }
}();

export default SettleAccountModel;


// WEBPACK FOOTER //
// ./src/models/SettleAccountModel.js